<template>
    <div>
        <v-card class="pa-2 mb-2">
            <v-row>
                <v-btn color="primary" class="ml-4" :disabled="!$global.login.administrator" @click="addFirm"><v-icon left>mdi-content-save</v-icon>Create Firm</v-btn>

                <v-dialog v-model="firmDialog" max-width="500px">
                    <v-card>
                        <v-card-title>
                        <span class="headline">Firm</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                    <v-row>
                                        <v-col>
                                            <v-text-field v-model="editedItem.firmGUID" label="Firm Code" @keyup="uppercase"></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-text-field v-model="editedItem.firm" label="Firm"></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-select :items="months" v-model="editedItem.expirationMonth" label="Expiration Month"></v-select>
                                        </v-col>
                                    </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn color="red darken-1" :disabled="addingFirm" text @click="resetPasswordsPrompt">Reset Passwords</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                            <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="firmResetDialog" max-width="256px">
                    <v-card>
                        <v-card-title>
                        <span class="headline">Reset Passwords</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                    <v-row>
                                        <v-col>
                                            <v-text-field v-model="resetting.managerPassword" label="Manager"></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-text-field v-model="resetting.seniorPassword" label="Senior"></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-text-field v-model="resetting.partnerPassword" label="Partner"></v-text-field>
                                        </v-col>
                                    </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="closeReset">Cancel</v-btn>
                            <v-btn color="blue darken-1" text @click="saveReset">Save</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
        </v-card>

        <v-card class="mb-2">
            <v-card-title class="pa-2">
                <v-row>
                    <v-col>
                        <label><v-icon left>mdi-magnify</v-icon>Search</label>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field ref="searchFor" label="Firm Code or Name" prepend-inner-icon="mdi-magnify" v-model="searchFor" outlined dense single-line rounded clearable hide-details @keyup.native="onKey"></v-text-field>
                    </v-col>
                    <v-col>
                        <v-btn color="primary" class="ml-4" @click="confirmLoadFirms"><v-icon left>mdi-magnify</v-icon>Search</v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
        </v-card>
        <v-card>
            <v-card-title class="pa-2">
                <v-row>
                    <v-col>
                        <label><v-icon left>mdi-hexagon</v-icon>Firms</label>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field v-model="table.search" label="Filter on any field" prepend-inner-icon="mdi-filter-outline" outlined dense single-line rounded clearable hide-details v-show="table.firms.length > 0"></v-text-field>
                    </v-col>
                    <v-col>
                    </v-col>
                </v-row>
            </v-card-title>

            <v-data-table dense :footer-props="table.footerProps"  v-model="table.selected" item-key="firm" :headers="table.headers" :items="table.firms" :search="table.search" :loading="isBusy" :loading-text="table.loadingText" class="elevation-1">
                <template v-slot:[`item.action`]="{ item }">
                    <v-icon :disabled="!$global.login.administrator" small @click="editFirm(item)">
                        mdi-pencil
                    </v-icon>
                </template>
            </v-data-table>
        </v-card>

        <v-snackbar v-model="snackbar.visible" color="primary" :timeout="snackbar.timeout" :bottom="snackbar.bottom">
            {{snackbar.message}}
            <v-btn dark text @click="snackbar.visible=false">
                Close
            </v-btn>
        </v-snackbar>

    </div>
</template>

<script>

export default {
    name: "FirmManager",
    data() {
        return {
            singleSelect: false,
            title: "Firms",
            isBusy: false,
            searching: true,
            firmDialog: false,
            firmResetDialog: false,
            editingFirm: {
                firmGUID: "",
                firm: "",
                expirationMonth: "",
            },
            searchFor: "",
            table: {
                selected: [],
                footerProps: { "items-per-page-options": [15, 25, 50, 100] },
                search: "",
                itemKey: "firmGUID",
                loadingText: "loading firms",
                headers: [
                    { text: "Firm Code", value: "firmGUID" },
                    { text: "Firm", value: "firm" },
                    { text: "Expiration Month", value: "expirationMonth" },
                    { text: "Actions", value: "action", sortable: false },
                ],
                firms: [],
            },
            addingFirm: false,
            editedIndex: -1,
            editedGUID: "",
            editedItem: {
                firmGUID: "",
                firm: "",
                expirationMonth: "",
            },
            defaultItem: {
                firmGUID: "",
                firm: "",
                expirationMonth: "Any",
            },
            resetting: {
                managerPassword: "",
                seniorPassword: "",
                partnerPassword: "",
            },
            months: ["Any", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            migrating: {
                firmGUID: "",
                expirationMonth: "",
                migrated: 0,
            },
            snackbar: {
                visible: false,
                timeout: 3000,
                bottom: true,
                message: "",
            },
        };
    },
    mounted() {
        this.$http
            .get(`/api/gui/pulse`)
            .catch((err) => {
                if (err.response.status === 401) {
                    this.$router.push({ name: "login" });
                }
            });
    },
    methods: {
        onKey(evt) {
            if (evt.key === "Enter") {
                this.confirmLoadFirms();
            }
        },
        onBackKey() {
            this.searching = true;
        },
        confirmLoadFirms() {
            if (this.searchFor === null) {
                this.searchFor = "";
            }
            if (this.searchFor === "") {
                this.$confirm({
                    title: "Confirm Search",
                    message: "Are you sure you wish to load the first 1000 firms?",
                }, (value) => {
                    if (value) {
                        this.loadFirms();
                    }
                });
            }
            else {
                this.loadFirms();
            }
        },
        loadFirms() {
            this.isBusy = true;
            this.table.firms = [];
            this.table.selected = [];
            this.$http
                .get(`/api/firm/search/${this.searchFor}/`)
                .then((response) => {
                    this.table.firms = response.data;
                    this.isBusy = false;

                    this.$ga.event({
                        eventCategory: "firms",
                        eventAction: "search",
                    });
                })
                .catch((err) => {
                    this.isBusy = false;
                    if (err.response.status === 401) {
                        this.$router.push({ name: "login" });
                    }
                    else {
                        this.$alert({ type: "error", title: "Search Failed", message: err });
                    }
                });
        },
        addFirm() {
            this.addingFirm = true;
            this.editedIndex = -1;
            this.editedGUID = "";
            this.editedItem = Object.assign({}, this.defaultItem);
            this.firmDialog = true;
        },
        editFirm(item) {
            this.addingFirm = false;
            this.editedIndex = this.table.firms.indexOf(item);
            this.editedGUID = item.firmGUID;
            this.editedItem = Object.assign({}, item);
            this.firmDialog = true;
        },
        resetPasswordsPrompt() {
            this.resetting.managerPassword = "";
            this.resetting.seniorPassword = "";
            this.resetting.partnerPassword = "";
            this.firmResetDialog = true;
        },
        closeReset() {
            this.firmResetDialog = false;
        },
        saveReset() {
            this.isBusy = true;
            this.$http
                .post(`/api/firm/reset`, {
                    firmGUID: this.editedItem.firmGUID,
                    managerPassword: this.resetting.managerPassword,
                    seniorPassword: this.resetting.seniorPassword,
                    partnerPassword: this.resetting.partnerPassword,
                })
                .then(() => {
                    this.isBusy = false;
                    this.firmResetDialog = false;
                    this.$ga.event({
                        eventCategory: "firms",
                        eventAction: "reset",
                    });
                })
                .catch((err) => {
                    this.isBusy = false;
                    if (err.response.status === 401) {
                        this.$router.push({ name: "login" });
                    }
                    else {
                        this.$alert({ type: "error", title: "Reset Failed", message: err.response.data.exceptionMessage });
                    }
                });
        },
        close() {
            this.firmDialog = false;
            setTimeout(() => {
                this.editedGUID = "";
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },
        save() {
            if (this.editedIndex > -1) {
                this.saveExistingFirm();
            }
            else {
                this.saveNewFirm();
            }
        },
        saveNewFirm() {
            if (this.editedItem.firmGUID === "" || this.editedItem.firm === "") {
                return;
            }
            this.isBusy = true;
            this.$http
                .post(`/api/firm/create`, {
                    applicationGUID: this.$global.application,
                    firmGUID: this.editedItem.firmGUID,
                    firm: this.editedItem.firm,
                    expirationMonth: this.editedItem.expirationMonth,
                })
                .then(() => {
                    this.isBusy = false;
                    this.table.firms.unshift(this.editedItem);
                    this.firmDialog = false;

                    this.$ga.event({
                        eventCategory: "firms",
                        eventAction: "create",
                    });
                })
                .catch((err) => {
                    this.isBusy = false;
                    if (err.response.status === 401) {
                        this.$router.push({ name: "login" });
                    }
                    else {
                        this.$alert({ type: "error", title: "Create Failed", message: err.response.data.exceptionMessage });
                    }
                });
        },
        saveExistingFirm() {
            this.isBusy = true;
            this.$http
                .post(`/api/firm/update`, {
                    applicationGUID: this.$global.application,
                    originalFirmGUID: this.editedGUID,
                    firmGUID: this.editedItem.firmGUID,
                    firm: this.editedItem.firm,
                    expirationMonth: this.editedItem.expirationMonth,
                })
                .then(() => {
                    this.isBusy = false;
                    Object.assign(this.table.firms[this.editedIndex], this.editedItem);
                    this.firmDialog = false;

                    this.$ga.event({
                        eventCategory: "firms",
                        eventAction: "update",
                    });
                })
                .catch((err) => {
                    this.isBusy = false;
                    if (err.response.status === 401) {
                        this.$router.push({ name: "login" });
                    }
                    else {
                        this.$alert({ type: "error", title: "Save Failed", message: err.response.data.exceptionMessage });
                    }
                });
        },
        uppercase() {
            this.editedItem.firmGUID = this.editedItem.firmGUID.toUpperCase();
        },
    },
};
</script>
